import React from 'react';
import classNames from 'classnames';

import css from './IconPlus.module.css';

/**
 * Open/close indicator for the sidebar filters.
 *
 * Note: renders a chevron rather than a plus — the name is kept because this is
 * imported by FilterPlain and BookingDateRangeFilter's sidebar variant, and both
 * only care about the isOpen/isSelected contract.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {boolean} [props.isOpen] - Whether the icon is showing the 'open' mode
 * @returns {JSX.Element}
 */
const IconPlus = props => {
  const { className, rootClassName, isOpen = true } = props;
  const classes = classNames(rootClassName || css.root, className, {
    [css.chevronOpen]: isOpen,
  });

  return (
    <svg
      className={classes}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      role="none"
    >
      <polyline
        className={css.chevron}
        points="2,4.5 6,8.5 10,4.5"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconPlus;
